/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import {  useSelector } from 'react-redux';
import DialogContainer from '../../../../../../../../components/shared/Dialog/DialogContainer';
import { FaHistory } from 'react-icons/fa';
import OrgAppUserHistory from './OrgAppUserHistory';
import OrgAppUserEdit from './OrgAppUserEdit';

const OrgAppsUsers = () => {
    const [selectedOrgAppsUsers, setSelectedOrgAppsUsers] = useState({});
    const [openEditOrgAppsUsers, setOpenEditOrgAppsUsers] = useState(false);
    const [openHistoryOrgAppsUsers, setOpenHistoryOrgAppsUsers] = useState(false);
    const orgAppsUsersList = useSelector(state => state.applicationUsers.orgAppsUsersList)

    const handleCloseDialog = () => {
        setOpenEditOrgAppsUsers(false);
        setOpenHistoryOrgAppsUsers(false);
    }

    return (
        <><TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell label="Organization Name" />
                        <StyledTableCell label="User ID" />
                        <StyledTableCell label="Application Name" />

                        <StyledTableCell label="Role Name" />

                        <StyledTableCell label="Details" />
                        <StyledTableCell label=" " />

                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {orgAppsUsersList?.Records?.length > 0 && orgAppsUsersList.Records.map((row) => (
                        <StyledTableRow key={row.organizationID}>
                            <StyledTableCell label={row.organizationName} />
                            <StyledTableCell label={row.getChkdID} />
                            <StyledTableCell label={row.applicationName} />

                            <StyledTableCell label={row.roleName} />

                            <StyledTableCell   >
                                {row.organizationApplicationUserDetails.length > 0 ?
                                    <Typography style={{ fontWeight: 'bold' }} color={row.organizationApplicationUserDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                        {row.organizationApplicationUserDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                    </Typography> : "N/A"}
                            </StyledTableCell>

                            <StyledTableCell align="right"  >
                                <Tooltip title=" User Edit" placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrgAppsUsers(row); setOpenEditOrgAppsUsers(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title=" User History" placement="left" arrow>

                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrgAppsUsers(row); setOpenHistoryOrgAppsUsers(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </Tooltip>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>


            <DialogContainer
                open={openEditOrgAppsUsers}
                handleClose={handleCloseDialog}
            >
                <OrgAppUserEdit
                    selectedOrgAppUser={selectedOrgAppsUsers}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryOrgAppsUsers}
                handleClose={handleCloseDialog}
            >
                <OrgAppUserHistory
                    selectedOrgAppUser={selectedOrgAppsUsers}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}


export default OrgAppsUsers;
